/* tslint:disable */
/* eslint-disable */
/* @relayHash b93149f9c6f2580a67ad258025d2af0e */

import { ConcreteRequest } from "relay-runtime";
export type TransactionVerifyEmailMutationInput = {
    emailVerificationToken: string;
    clientMutationId?: string | null;
};
export type verifyEmailHandlerMutationVariables = {
    input: TransactionVerifyEmailMutationInput;
};
export type verifyEmailHandlerMutationResponse = {
    readonly transactionVerifyEmail: {
        readonly __typename: string;
    } | null;
};
export type verifyEmailHandlerMutation = {
    readonly response: verifyEmailHandlerMutationResponse;
    readonly variables: verifyEmailHandlerMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TransactionVerifyEmailMutationPayload",
    "kind": "LinkedField",
    "name": "transactionVerifyEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyEmailHandlerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyEmailHandlerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/316.0.0-2021-05-20T20:01:12.438Z/verifyEmailHandlerMutation",
    "metadata": {},
    "name": "verifyEmailHandlerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '038df1e8cb2211f8d718a9b6dd594b40';
export default node;
